import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-lg leading-6 font-medium text-gray-900" }
const _hoisted_2 = { class: "flex flex-col gap-5 border rounded-xl p-4 mt-4 shadow" }
const _hoisted_3 = { class: "flex flex-col gap-4" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "flex mt-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_9 = ["disabled"]

import { Form, SubmissionHandler } from "vee-validate";
import { computed, PropType, Ref } from "vue";
import { useI18n } from "vue-i18n";
import * as yup from "yup";
import FloatField from "@/components/forms/FloatField.vue";
import LoadingSpinner from "@/components/loading_state/LoadingSpinner.vue";
import ModalTW from "@/components/modals/ModalTW.vue";
import InfoTooltip from "@/components/tooltips/TooltipInfo.vue";
import numberService from "@/services/numberService";
import { UnitValue, UnitValueColumnModalForm, UnitValueType } from "@/types/UnitValue";
import ColumnModalTypeField from "@/views/unit_values/components/ColumnModalTypeField.vue";
import { precision } from "../services/unitValues";


export default /*#__PURE__*/_defineComponent({
  __name: 'ColumnModal',
  props: {
  existingTypes: {
    type: Array as PropType<UnitValueType[]>,
    required: true,
  },
  unitValue: {
    type: Object as PropType<UnitValue | null>,
    required: false,
  },
  canDelete: {
    type: Boolean,
    required: true,
  },
},
  emits: ["closed", "confirmed", "deleted"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();

const props = __props;

const emit = __emit;

const schema = yup.object({
  type: yup.string().required(t("unit_values.column_modal.validation_type_required")),
  type_duration_factor: yup
    .number()
    .nullable()
    .typeError(t("unit_values.column_modal.invalid_number")),
  type_workforce_delta: yup
    .number()
    .nullable()
    .typeError(t("unit_values.column_modal.invalid_number")),
  type_value_delta: yup.number().nullable().typeError(t("unit_values.column_modal.invalid_number")),
});

const initialValues: Ref<Partial<UnitValueColumnModalForm>> = computed(() => ({
  type: props.unitValue?.type,
  type_duration_factor:
    props.unitValue && props.unitValue.type_duration_factor !== null
      ? props.unitValue?.type_duration_factor * 100
      : null,
  type_workforce_delta: props.unitValue?.type_workforce_delta ?? null,
  type_value_delta: props.unitValue?.type_value_delta ?? null,
}));

const handleSubmit: SubmissionHandler = async (genericObject) => {
  const values = genericObject as UnitValueColumnModalForm;
  const finalValues: UnitValueColumnModalForm = {
    ...values,
    type_duration_factor:
      values.type_duration_factor !== null
        ? numberService.fixToPrecision(values.type_duration_factor / 100, precision + 2)
        : null,
  };
  emit("confirmed", finalValues);
  // Show spinner indefinitely. When parent is ready, it'll close this modal
  await new Promise(() => undefined);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalTW, {
    open: true,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('closed'))),
    customCls: "w-full m-2 lg:w-1/3",
    style: {"min-width":"500px"}
  }, {
    title: _withCtx(() => [
      _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.$t(
            __props.unitValue
              ? "unit_values.column_modal.title_edit"
              : "unit_values.column_modal.title_add",
          )), 1)
    ]),
    content: _withCtx(() => [
      _createVNode(_unref(Form), {
        onSubmit: handleSubmit,
        initialValues: initialValues.value,
        validationSchema: _unref(schema),
        class: "text-left flex flex-col gap-4"
      }, {
        default: _withCtx(({ isSubmitting }) => [
          _createVNode(ColumnModalTypeField, { existingTypes: __props.existingTypes }, null, 8, ["existingTypes"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t("unit_values.column_modal.cleaned_unit_values_header")), 1),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(FloatField, { name: "type_duration_factor" }, {
                label: _withCtx(() => [
                  _createElementVNode("span", _hoisted_4, [
                    _createTextVNode(_toDisplayString(`${_ctx.$t("unit_values.column_modal.type_duration_factor")} (%)`) + " ", 1),
                    _createVNode(InfoTooltip, { hoverStyle: "max-width: 250px" }, {
                      text: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("unit_values.column_modal.type_duration_factor_tooltip")), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(FloatField, { name: "type_workforce_delta" }, {
                label: _withCtx(() => [
                  _createElementVNode("span", _hoisted_5, [
                    _createTextVNode(_toDisplayString(_ctx.$t("unit_values.column_modal.type_workforce_delta")) + " ", 1),
                    _createVNode(InfoTooltip, { hoverStyle: "max-width: 250px" }, {
                      text: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("unit_values.column_modal.type_workforce_delta_tooltip")), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(FloatField, { name: "type_value_delta" }, {
                label: _withCtx(() => [
                  _createElementVNode("span", _hoisted_6, [
                    _createTextVNode(_toDisplayString(_ctx.$t("unit_values.column_modal.type_value_delta")) + " ", 1),
                    _createVNode(InfoTooltip, {
                      hoverStyle: "max-width: 250px",
                      alignCls: "tooltip-left"
                    }, {
                      text: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("unit_values.column_modal.type_value_delta_tooltip")), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            (__props.unitValue && __props.canDelete)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "focus:outline-none flex justify-center rounded-md border border-transparent bg-red-500 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-red-600 focus:ring-0",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('deleted', __props.unitValue.type)))
                }, _toDisplayString(_ctx.$t("buttons.delete")), 1))
              : _createCommentVNode("", true),
            _hoisted_8,
            _createElementVNode("button", {
              type: "submit",
              class: "focus:outline-none flex justify-center rounded-md border border-transparent bg-yellow-500 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-yellow-600 focus:ring-0 disabled:cursor-default disabled:bg-gray-300",
              disabled: isSubmitting
            }, [
              isSubmitting
                ? (_openBlock(), _createBlock(LoadingSpinner, {
                    key: 0,
                    size: "w-5 h-5",
                    color: "white",
                    class: "mr-2"
                  }))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("buttons.apply")), 1)
            ], 8, _hoisted_9)
          ])
        ]),
        _: 1
      }, 8, ["initialValues", "validationSchema"])
    ]),
    _: 1
  }))
}
}

})